import styled from "styled-components";
import { Flex, Grid } from "../../common/Layouts/styles";
import {
  BrightCTAColor,
  fadingTextColor,
  secondaryColor,
} from "../../styles/styles";

export const ProjectsTitle = styled("h1")`
  margin: 3rem 0;
  font-weight: 400;
`;

export const ProjectsDescription = styled("h3")`
  position: sticky;
  align-self: flex-start;
  top: 2vw;
`;

export const Paragraph = styled("p")`
  font-size: 2vw;
  line-height: 2.4vw;
`;

export const GridContainer = styled(Grid)`
  grid-template-columns: repeat(2, minmax(100px, 1fr));
  gap: 3rem;
  margin-top: 4rem;
`;

export const Container = styled("div")`
  padding: 2.4vw;
  background-color: ${secondaryColor};
  border-radius: 10px;
  min-width: 24vw;
  position: relative;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 4vw;
    min-width: 75vw;
  }
`;

export const Content = styled(Flex)`
  margin-top: 1vw;
  height: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin-top: 3vw;
  }
`;

export const FadingId = styled("h4")`
  color: ${fadingTextColor};
  margin-bottom: 2vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 6em;
    margin-bottom: 4vw;
  }
`;

export const Inner = styled("div")`
  position: relative;
  height: 100%;

  &:after {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 1) 70%
    );
    width: 100%;
    height: 4em;
  }

  &:before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 1) 70%
    );
    width: 100%;
    height: 4em;
  }
`;

export const Title = styled("h2")`
  font-weight: 400;
  color: ${BrightCTAColor};
  margin-top: 1vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 8em;
    margin-top: 4.6vw;
  }
`;

export const MiniTitle = styled("span")`
  position: relative;
  margin-left: 1rem;
  top: -0.4rem;
  padding: 0 0.5rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  border: 1px solid #ccc;
  font-size: 0.9vw;
`;

export const Description = styled("p")`
  color: ${fadingTextColor};
  margin-top: 1.6rem;
  font-size: 1vw;
  line-height: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 4em;
    line-height: 18px;
  }
`;

export const FlexContainer = styled(Flex)`
  width: 100%;
`;

export const TopLineFlex = styled(Flex)`
  border-top: 1px solid ${fadingTextColor};
  /* padding: 0.6vw 0; */

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding-top: 1vw;
  }
`;

export const CharDataContainer = styled(Flex)`
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const CharDataItem = styled("span")`
  border: 1px solid #333;
  align-self: flex-start;
  padding: 0 0.5rem;
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
  color: ${fadingTextColor};
`;

export const LogoContainer = styled(Flex)`
  flex-direction: column;
  margin-top: 0.8rem;
  justify-content: center;
  gap: 0.5rem;
`;
